import { Asset, Title } from "@sicredi/react";
import React from "react";

export default function AuthenticatingErrorPage() {
  return (
    <div
      style={{
        margin: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Title as="h1">Erro na autenticação</Title>
      <Asset name="action-error" />
    </div>
  );
}
